import { useWorkspaceId } from "@/hooks/use-workspace";
import { useBrand } from "@/hooks/use-brand";
import { useLandingsList } from "@/hooks/use-landings-list";

export default function AppPrefetch() {
  const { data: workspaceId } = useWorkspaceId();
  useBrand();
  useLandingsList(workspaceId);

  return null;
}
